import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import { IRegistration } from '../../yogAdmin.duck';

type IModalProps = {
  cancelCallBack: () => void;
  confirmCallBack: (registration: IRegistration) => void;
  registration: IRegistration;
  isUpdatingRegistration: boolean;
};

export function ConfirmRemoveHoldModal({
  cancelCallBack,
  confirmCallBack,
  registration,
  isUpdatingRegistration
}: IModalProps) {
  const { classes } = useStyles();
  const {
    member: { firstName, lastName }
  } = registration;
  return (
    <Fragment>
      <DialogTitle className={classes.dialogTitle}>
        Are you sure you want to Remove Hold?
      </DialogTitle>
      <DialogContent className={classes.container}>
        <div className={classes.text}>
          You are Remove Holding registration for:{' '}
          <span className={classes.name}>
            {firstName} {lastName}
          </span>
          <div className={classes.note}>
            Note: The hold on this registration will be lifted for one day.
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button disableRipple className="button-primary cancel-button" onClick={cancelCallBack}>
          <span className="button-primary-label">Cancel</span>
        </Button>
        <Button
          disableRipple
          disabled={isUpdatingRegistration}
          className="button-primary"
          style={{ backgroundColor: '#C84240' }}
          onClick={() => confirmCallBack(registration)}
        >
          <span className="button-primary-label label-white">Remove Hold</span>
        </Button>
      </DialogActions>
    </Fragment>
  );
}

export const useStyles = makeStyles()(() => ({
  dialogTitle: {
    '> h2': {
      fontSize: '18px',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: 'Rubik'
    }
  },
  note: {
    fontSize: '14px',
    marginTop: '16px',
    backgroundColor: '#E8EBF4',
    padding: '4px 8px',
    borderRadius: '4px'
  },
  text: {
    fontFamily: 'Rubik'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    fontFamily: 'Rubik',
    marginBottom: '16px'
  },
  name: {
    fontWeight: 'bold',
    textTransform: 'capitalize'
  }
}));
